import React from 'react';
import { Loader } from '@getro/rombo';
import PropTypes from 'prop-types';
import { Flex } from 'rebass/styled-components';

import { trackEvent } from '../../../../../helpers/analytics';
import { useCreateNoteMutation } from '../../../../../services/contacts';
import { NoteForm } from '../noteForm';
import { useNoteDraft } from '../noteForm/useNoteDraft';

export const NewNote = ({ queryParams, contactId }) => {
  const [createNote, { isLoading }] = useCreateNoteMutation();
  const { draft, isLoading: isDraftLoading, saveDraft, clearDraft } = useNoteDraft({ contactId });

  const onSave = async (values, { resetForm }) => {
    trackEvent('contacts:notes:add', {
      origin: 'full_profile',
    });
    const result = await createNote({ queryParams, contactId, values });
    // Only clear draft and reset form if the request was successful
    if (!result.error) {
      clearDraft();
      resetForm();
    }
  };

  if (isDraftLoading) {
    return (
      <Flex justifyContent="center" py={3}>
        <Loader size="small" />
      </Flex>
    );
  }

  return <NoteForm onSuccess={onSave} isLoading={isLoading} draft={draft} onDraftChange={saveDraft} />;
};

NewNote.propTypes = {
  queryParams: PropTypes.object,
  contactId: PropTypes.number.isRequired,
};

NewNote.defaultProps = {
  queryParams: {},
};
